import React from "react";

export default function AlertIcon() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5693 13.5395L8.38935 1.62945C8.04935 0.959453 6.95935 0.959453 6.60935 1.62945L0.429347 13.5395C0.269347 13.8495 0.279347 14.2195 0.459347 14.5195C0.639347 14.8195 0.969347 14.9995 1.31935 14.9995H13.6793C14.0293 14.9995 14.3493 14.8195 14.5293 14.5195C14.7093 14.2195 14.7293 13.8495 14.5693 13.5395ZM6.99935 5.99945C6.99935 5.71945 7.21935 5.49945 7.49935 5.49945C7.77935 5.49945 7.99935 5.71945 7.99935 5.99945V9.49945C7.99935 9.77945 7.77935 9.99945 7.49935 9.99945C7.21935 9.99945 6.99935 9.77945 6.99935 9.49945V5.99945ZM7.49935 12.9995C6.94935 12.9995 6.49935 12.5495 6.49935 11.9995C6.49935 11.4495 6.94935 10.9995 7.49935 10.9995C8.04935 10.9995 8.49935 11.4495 8.49935 11.9995C8.49935 12.5495 8.04935 12.9995 7.49935 12.9995Z"
          fill="#ED8F1C"
        />
      </svg>
    </>
  );
}
